import { ThemeSettingsValueProps } from 'src/components/settings/types';
import {
  VideoFilterParamsType,
  VideoFilterType,
} from 'src/provider/VoiceChannel/livekit/types';

export type UIArea = 'communicate' | 'collaborate' | 'ai';

export enum UIFeature {
  recents = 'recents',
  gathering = 'gathering',
  channels = 'channels',
  p2p = 'p2p',
  todos = 'todos',
  boards = 'boards',
  docs = 'docs',
  drive = 'drive',
  topics = 'topics',
}

export enum TodoView {
  FULL = 'full',
  DAYS = 'days',
  COLUMNS = 'columns',
}

export type DriveViewType = 'list' | 'grid';

export interface DriveUIState {
  driveViewType: DriveViewType;
  setDriveViewType: (viewType: DriveViewType) => void;
}

export type GroupState = {
  viewType: TodoView;
  columnNumber: number;
  expandedSubList: boolean;
  activeSubList: number;
  sublistHeight: number;
  sublistColsWidth: Record<string, number>;
};

export type BoardState = {
  lastTable?: string;
  hideActivities?: boolean;
};

export interface UIState {
  navBarHidden: Record<UIArea, boolean>;
  navBarExpanded: Record<UIFeature, boolean>;
  driveViewType: DriveViewType;
  docsFullWidth: boolean;
  docScrollHeight: Record<string, number>;
  docsExpanded: Record<string, boolean>;
  toDoGroupStates: Record<string, GroupState>;
  meetLastPopPosition: popupPosition;
  preferenceState: Record<string, ThemeSettingsValueProps>;
  dismissLanguageModal: boolean;

  setNavBarHidden: (area: UIArea, hidden: boolean) => void;
  setNavBarExpanded: (feature: UIFeature, expanded: boolean) => void;
  setDriveViewType: (viewType: DriveViewType) => void;
  setDocsFullWidth: (expanded: boolean) => void;
  setDocScrollHeight: (docId: string, height: number) => void;
  setDocExpanded: (docId: string, expanded: boolean) => void;
  setToDoGroupState: (groupId: string, state: Partial<GroupState>) => void;
  setMeetLastPopPosition: (position: popupPosition) => void;
  setPreferenceState: (
    userId: string,
    state: Partial<ThemeSettingsValueProps>,
  ) => void;
  setDismissLanguageModal: (dismissLanguageModal: boolean) => void;
  reset(): void;

  docsIDList: string[];
  addDocToList: (docId: string) => void;
  deleteDocFromList: (docId: string) => void;

  chatIDList: string[];
  addChatToList: (chatId: string) => void;
  deleteChatFromList: (chatId: string) => void;

  // VOICE STATES
  videoFilter: VideoFilterType | null;
  setVideoFilter: (videoFilter: VideoFilterType) => void;
  filterParams: VideoFilterParamsType;
  setFilterParams: (filterParam: Partial<VideoFilterParamsType>) => void;
  uploadedURLs: string[];
  setUploadedURLs: (uploadedURLs: string[]) => void;
  micMuted: boolean;
  setMicMuted: (muted: boolean) => void;
}

export interface DocsUIState {
  docsFullWidth: boolean;
  setDocsFullWidth: (expanded: boolean) => void;
  docScrollHeight: number;
  setDocScrollHeight: (height: number) => void;
  docsExpanded: boolean;
  setDocsExpanded: (expanded: boolean) => void;
}

export interface DocsActionBarUIState {
  docsIDList: string[];
  addDocToList: (docId: string) => void;
  deleteDocFromList: (docId: string) => void;
}

export interface ChatActionBarUIState {
  chatIDList: string[];
  addChatToList: (chatId: string) => void;
  deleteChatFromList: (chatId: string) => void;
}

export interface popupPosition {
  x: number;
  y: number;
  height: number;
  width: number;
}

export interface TodoUIState {
  groupState: GroupState | undefined;
  setGroupState: (todoStates: Partial<GroupState>) => void;
}

export interface PreferenceUIState {
  preferenceState: ThemeSettingsValueProps | undefined;
  setPreferenceState: (preferenceState: ThemeSettingsValueProps) => void;
}
